import { Icon, IconProps } from ".";

export const City = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M16.5 4.80005H11.1V7.50005H9.3V5.47505V4.80005H7.95V5.47505V7.50005H6.15V5.47505V4.80005H4.8V5.47505V7.50005H3V10.2V19.2H11.1H12.9H16.5H21V10.2H16.5V4.80005ZM19.2 14.7V16.5H17.4V14.7H19.2ZM8.4 14.7H10.2V16.5H8.4V14.7ZM6.6 16.5H4.8V14.7H6.6V16.5ZM17.4 12H19.2V13.8H17.4V12ZM4.8 9.30005H6.6V11.1H4.8V9.30005ZM10.2 12V13.8H8.4V12H10.2ZM10.2 9.30005V11.1H8.4V9.30005H10.2ZM4.8 13.8V12H6.6V13.8H4.8ZM14.7 12V13.8H12.9V12H14.7ZM12.9 6.60005H14.7V8.40005H12.9V6.60005ZM14.7 9.30005V11.1H12.9V9.30005H14.7Z" />
    </Icon>
  );
};
